import { createWebHistory, createRouter } from "vue-router";
import { useStore } from 'vuex'
import { computed } from 'vue'
import { Document, Application, Report, Setting,Standard } from '@/icons'
import { checkRoutePermission, initPermission } from '@/tools'

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            redirect: '/report'
        },
        {
            path: '/login',
            name: 'Login',
            component: () => import('@/views/login.vue'),
            meta: {
                needLogin: false
            }
        },
        {
            path: '/forget',
            name: 'Forget',
            component: () => import('@/views/forget.vue'),
            meta: {
                needLogin: false
            }
        },
        {
            path: '/registerSubject/:code',
            name: 'RegisterSubject',
            component: () => import('@/views/RegisterSubject.vue'),
            props: true,
            meta: {
                needLogin: false
            }
        },
        {
            path: '/fillSuccess',
            name: 'FillSuccess',
            component: () => import('@/views/RegisteredSuccess.vue'),
            meta: {
                needLogin: false
            }
        },
        {
            path: '/invalidLink',
            name: 'InvalidLink',
            component: () => import('@/views/InvalidLink.vue'),
            meta: {
                needLogin: false
            }
        },
        {
            path: '/:catchAll(.*)',  //也可以直接写 '*'
            component: () => import('@/views/notFound.vue'),
            meta: {
                needLogin: false
            }
        },
        {
            path: '/error',
            name: 'Error',
            component: () => import('@/views/startPage.vue'),
            children: [
                {
                    path: '/nopermission',
                    name: 'NoPermission',
                    component: () => import('@/views/notFound.vue'),
                    meta: {
                        needLogin: false
                    }
                }
            ]
        },
        {
            path: '/documents',
            name: 'Documents',
            component: () => import('@/views/startPage.vue'),
            meta: {
                icon: Document,
                needLogin: true,
                root: true,
                showSubItem: true,
                enable: false
            },
            children: [
                {
                    path: 'athleteDocuments',
                    name: 'AthleteDocuments',
                    component: () => import('@/views/Document/athleteDocuments.vue'),
                    meta: {
                        needLogin: true,
                        enable: false,
                        keepAlive: true,
                        permission: [
                            { key: "Create", name: "global.Create", value: false },
                            { key: "ViewPersonDocument", name: "Documents.Lable.ViewPersonDocument", value: false },
                            { key: "InvationInfo", name: "Documents.Lable.InvationInfo", value: false },
                            { key: "DeleteInvation", name: "Documents.Lable.DeleteInvation", value: false },
                            { key: "Edit", name: "global.EditSubject", value: false },
                            { key: "EditRelation", name: "global.EditRelation", value: false },
                            { key: "ViewHistoryRecords", name: "Documents.Lable.ViewHistoryRecords", value: false },
                            { key: "ViewDetailRecords", name: "Documents.Lable.ViewDetailRecords", value: false },
                            { key: "TestDetialExport", name: "Documents.Lable.TestDetialExport", value: false },
                            { key: "ViewActionDetail", name: "Documents.Lable.ViewActionDetail", value: false },
                            { key: "ActionDataExport", name: "Documents.Lable.ActionDataExport", value: false }
                        ]
                    }
                },
                {
                    path: 'sportProject',
                    name: 'SportProject',
                    component: () => import('@/views/Document/projectDocuments.vue'),
                    meta: {
                        needLogin: true,
                        enable: false,
                        permission: [
                            { key: "View", name: "global.View", value: false },
                            { key: "Create", name: "global.Create", value: false },
                            { key: "Delete", name: "global.Delete", value: false },
                            { key: "Edit", name: "global.EditProject", value: false },
                            { key: "EditRelation", name: "global.EditRelation", value: false }
                        ]
                    }
                },
                {
                    path: 'Subject/:id',
                    name: 'Subject',
                    component: () => import('@/views/PersonnelManagement/personnelManagement.vue'),
                    props: true,
                    meta: {
                        hidden: true,
                        needLogin: true,
                        enable: true,
                        keepAlive: true,
                        bind: ["Documents.AthleteDocuments.ViewPersonDocument"]
                    }
                },
                {
                    path: 'Record/:id/:subjetName/:aid',
                    name: 'Record',
                    component: () => import('@/views/PersonnelManagement/viewPersonnelRecord.vue'),
                    props: true,
                    meta: {
                        hidden: true,
                        needLogin: true,
                        keepAlive: true,
                        bind: ["Documents.AthleteDocuments.ViewHistoryRecords"]
                    }
                },
                {
                    path: 'result',
                    name: 'Result',
                    component: () => import('@/views/PersonnelManagement/testResult.vue'),
                    props: true,
                    meta: {
                        hidden: true,
                        needLogin: true,
                        bind: ["Documents.AthleteDocuments.ViewDetailRecords"]
                    }
                },
                {
                    path: 'muscleStrengthResult',
                    name: 'MuscleStrengthResult',
                    component: () => import('@/views/PersonnelManagement/Result/muscleStrengthResult.vue'),
                    props: true,
                    meta: {
                        hidden: true,
                        needLogin: true,
                        bind: ["Documents.AthleteDocuments.ViewDetailRecords"]
                    }
                },
                {
                    path: 'sportsPerformanceResult',
                    name: 'SportsPerformanceResult',
                    component: () => import('@/views/PersonnelManagement/Result/sportsPerformanceResult.vue'),
                    props: true,
                    meta: {
                        hidden: true,
                        needLogin: true,
                        bind: ["Documents.AthleteDocuments.ViewDetailRecords"]
                    }
                },
                {
                    path: 'rangeOfMotionResult',
                    name: 'RangeOfMotionResult',
                    component: () => import('@/views/PersonnelManagement/Result/rangeOfMotionResult.vue'),
                    props: true,
                    meta: {
                        hidden: true,
                        needLogin: true,
                        bind: ["Documents.AthleteDocuments.ViewDetailRecords"]
                    }
                },
                {
                    path: 'hamstringsResult',
                    name: 'HamstringsResult',
                    component: () => import('@/views/PersonnelManagement/Result/hamstringsResult.vue'),
                    props: true,
                    meta: {
                        hidden: true,
                        needLogin: true,
                        bind: ["Documents.AthleteDocuments.ViewDetailRecords"]
                    }
                },
                {
                    path: 'powerRackResult',
                    name: 'PowerRackResult',
                    component: () => import('@/views/PersonnelManagement/Result/powerRackResult.vue'),
                    props: true,
                    meta: {
                        hidden: true,
                        needLogin: true,
                        bind: ["Documents.AthleteDocuments.ViewDetailRecords"]
                    }
                },
                {
                    path: 'Actions/:actioninfos',
                    name: 'Actions',
                    component: () => import('@/views/PersonnelManagement/actionDetails.vue'),
                    props: true,
                    meta: {
                        hidden: true,
                        needLogin: true,
                        bind: ["Documents.AthleteDocuments.ViewActionDetail"]
                    }
                }
            ]
        },
        {
            path: '/applications',
            name: 'Applications',
            component: () => import('@/views/startPage.vue'),
            redirect: '/applications/applicationOverview',//首页内容的默认跳转
            meta: {
                icon: Application,
                needLogin: true,
                root: true,
                keepAlive: true,
                enable: true
            },
            children: [
                {
                    path: 'applicationOverview',
                    name: 'ApplicationOverview',
                    component: () => import('@/views/Applications/applicationOverview.vue'),
                    meta: {
                        hidden: true,
                        needLogin: true,
                        keepAlive: true
                    }
                },
                {
                    path: 'applicationDetail',
                    name: 'ApplicationDetail',
                    component: () => import('@/views/Applications/applicationDetail.vue'),
                    meta: {
                        hidden: true,
                        needLogin: true
                    }
                },
                {
                    path: 'projectRecordView',
                    name: 'ProjectRecordView',
                    component: () => import('@/views/Applications/Projects/projectRecordView.vue'),
                    meta: {
                        hidden: true,
                        needLogin: true
                    }
                },
                {
                    path: 'trainingPlanRecordView',
                    name: 'TrainingPlanRecordView',
                    component: () => import('@/views/Applications/TrainingPlan/trainingPlanRecordView.vue'),
                    meta: {
                        hidden: true,
                        needLogin: true
                    }
                }
            ]
        },
        {
            path: '/report',
            name: 'Report',
            component: () => import('@/views/startPage.vue'),
            redirect: '/report/analystReports',//首页内容的默认跳转            
            meta: {
                icon: Report,
                needLogin: true,
                root: true,
                enable: true
            },
            children: [
                {
                    path: 'analystReports',
                    name: 'AnalystReports',
                    component: () => import('@/views/Reports/analystReports.vue'),
                    meta: {
                        hidden: true,
                        needLogin: true,
                        keepAlive: true
                    }
                },
                {
                    path: 'reportDetail',
                    name: 'ReportDetail',
                    component: () => import('@/views/Reports/reportDetail.vue'),
                    meta: {
                        hidden: true,
                        needLogin: true,
                        enable: false,
                        permission: [
                            { key: "Export", name: "Report.Label.Export", value: false },
                        ]
                    }
                }
            ]
        },
        {
            path: '/standardData',
            name: 'StandardData',
            component: () => import('@/views/startPage.vue'),
            meta: {
                icon: Standard,
                needLogin: true,
                showSubItem: true,
                root: true,
                omPermission: true
            },
            children: [
                {
                    path: 'muscleStrengthStandardData',
                    name: 'MuscleStrengthStandardData',
                    component: () => import('@/views/Settings/muscleStrengthStandardData.vue'),
                    meta: {
                        needLogin: true,
                        enable: false,
                        //omPermission: true,                       
                    }
                },
                {
                    path: 'sportsPerformanceStandardData',
                    name: 'SportsPerformanceStandardData',
                    component: () => import('@/views/Settings/sportsPerformanceStandardData.vue'),
                    meta: {
                        needLogin: true,
                        enable: false,
                        //omPermission: true,                        
                    }
                }
            ]
        },
        {
            path: '/setting',
            name: 'Setting',
            component: () => import('@/views/startPage.vue'),
            //redirect:'/setting/options',//首页内容的默认跳转
            meta: {
                icon: Setting,
                needLogin: true,
                showSubItem: true,
                root: true,
                enable: true
            },
            children: [
                {
                    path: 'options',
                    name: 'Options',
                    component: () => import('@/views/Settings/globalOptions.vue'),
                    meta: {
                        needLogin: true,
                        enable: true,
                        permission: [
                            { key: "logo", name: "options.Lable.Logo", value: false },
                        ]
                    }
                },
                {
                    path: 'userManagement',
                    name: 'UserManagement',
                    component: () => import('@/views/Settings/userManagement.vue'),
                    meta: {
                        needLogin: true,
                        enable: false,
                        permission: [
                            { key: "Create", name: "global.Create", value: false },
                            { key: "Information", name: "UserManagement.Label.ModifyAccountInfo", value: false },
                            { key: "Permission", name: "UserManagement.Label.ModifyPermission", value: false },
                            { key: "Disable", name: "UserManagement.Label.Disable", value: false },
                            { key: "Enable", name: "UserManagement.Label.Enanble", value: false },
                            { key: "Delete", name: "UserManagement.Label.Delete", value: false },
                            { key: "ShowDisabled", name: "UserManagement.Label.Disabled", value: false }
                        ]
                    }
                },
                {
                    path: 'permission',
                    name: 'Permission',
                    component: () => import('@/views/Settings/permission.vue'),
                    meta: {
                        needLogin: true,
                        enable: false,
                        permission: [
                            { key: "Create", name: "global.Create", value: false },
                            { key: "Modify", name: "global.Modify", value: false },
                            { key: "Delete", name: "global.Delete", value: false },
                        ]
                    }
                }
            ]
        },
    ]
});

let originPush = router.push;

router.push = (to) => {
    to.query = { ...to.query, ...{ timestamp: new Date().valueOf() } }
    return originPush(to);
}

router.beforeEach((to, from, next) => {
    //检查缓存、session等 判断是否需要拦截跳转登录界面   
    if (to.meta.needLogin) {
        const store = useStore();
        const userObj = computed({
            get: () => store.state.userMenu,
            set: (val) => {
                store.dispatch('setUser', val);
            }
        });

        if (!userObj.value.account) {
            if (localStorage.getItem('User')) {
                userObj.value = JSON.parse(localStorage.getItem('User'));
            }
            else {
                //未登录
                next({ name: 'Login' });
                return;
            }
        }

        if (userObj.value.expiration < new Date().getTime()) {
            //已过期
            next({ name: 'Login' });
            return;
        }
        else {
            userObj.value.expiration = new Date().getTime() + (30 * 60 * 1000);
            localStorage.setItem('User', JSON.stringify(userObj.value))
        }

        initPermission(from.path === '/').then(() => {
            if (checkRoutePermission(to.matched))
                next();
            else {
                next({ name: 'NoPermission' });
            }
        });
    }
    else
        next();

    router.push = (to) => {
        to.query = { ...to.query, ...{ timestamp: new Date().valueOf() } }
        return originPush(to);
    }

})

export default router;

